<template>
    <administrative>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <form @submit.prevent="submitForm" novalidate enctype="multipart/form-data">
                    <div>

                        <div class="grid grid-cols-8 gap-4 mb-4">
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Select Month'"/>
                                <breeze-input type="month" required v-model="form.month" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.month:''" />
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <div class="grid grid-cols-8 gap-4 mb-4 items-center" v-for="detail,index in form.details" :key="index">
                                    <div class="col-span-2 sm:col-span-2">
                                        <breeze-label :value="'Select Salary Head'"/>
                                        <select-list :options="salaryheads" v-model="form.details[index].head"></select-list>
                                        <!-- <breeze-input-error :message="form.errors?form.errors.month:''" /> -->
                                    </div>
                                    <div class="col-span-2 sm:col-span-2">
                                        <breeze-label :value="'Value'"/>
                                        <breeze-input required v-model="form.details[index].value" class="w-full"/>
                                        <!-- <breeze-input-error :message="form.errors?form.errors.value:''" /> -->
                                    </div>
                                    <div class="col-span-3 sm:col-span-3">
                                        <breeze-label :value="'Remark'"/>
                                        <breeze-input v-model="form.details[index].remark" class="w-full"/>
                                        <!-- <breeze-input-error :message="form.errors?form.errors.value:''" /> -->
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <breeze-button :type="'button'" @click="addField()" class="mb-2">Add</breeze-button>
                    </div>

                    <button-link :href="route('administrative.faculty.view',faculty.id)" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </administrative>
</template>

<script>
    import Administrative from '@/Pages/Administrative/Administrative'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import InputCheckbox from '@/Components/InputCheckbox'
    import Loading from '@/Components/Loading'
    import SelectList from '@/Components/SelectList'

    export default {
        components: {
            Administrative,
            BreezeTable,
            ButtonLink,
            BreezeInput,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            InputCheckbox,
            Loading,
            SelectList
        },
        props:['faculty','salaryheads'],
        data(){
            return{
                form: useForm({
                    month: '',
                    details:[],
                })
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('administrative.faculty.salary.store',this.faculty.id),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
            addField(){
                this.form.details.push({head:'',value:'',remark:''});
            }
        },
    }
</script>
